import Grid from '@mui/material/Grid2';
import React, { useState, useEffect } from 'react';
import logo from "../../assets/img/HBL_logo.webp";
import ProgressBar from "@components/input/ProgressBar";

interface Props { 
  height?: number | string;
  width?: number | string;
  vertical?: boolean;
  size?: number;
  message?: string;
  percentage?: number;
}

export default function LoadingBox({ 
  height = "100%",
  width = "calc(100% - 10px)",
  vertical = false,
  size = -1,
  message = "Loading",
  percentage
}: Props) {
  // const [ping, setPing] = useState(false);
  const [prev_message, setPrevMessage] = useState(message);
  const [prev_percentage, setPrevPercentage] = useState(percentage === undefined ? 0 : percentage);
  const [useHeight, setHeight] = useState<number | string>(height);
  const [useWidth, setWidth] = useState<number | string>(width);

  useEffect(() => {
    setHeight(height);
  }, [height]);

  useEffect(() => {
    if (message !== prev_message || 
      percentage !== prev_percentage) {
      setPrevMessage(message);
      setPrevPercentage(percentage === undefined ? 0 : percentage);
    }
  }, [message, prev_message, percentage, prev_percentage]);
  
  useEffect(() => {
    setWidth(width);
  }, [width]);

  // debugger;
  if (size === -1) {
    if (vertical) {
      return (
        <Grid container spacing={0} direction="row" style={{ height: useHeight, width: useWidth }}>
          <Grid
            size={{
              xs: 12
            }}>
            <img src={logo} alt="logo" className="App-logo" />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            {/* { !prev_percentage ? 
              prev_message 
            : */}
              <ProgressBar
                message={prev_message}
                value={prev_percentage}
              />
            {/* } */}
          </Grid>
        </Grid>
      );
    } else {
      return (
        <div style={{ height: useHeight, width: useWidth }}>
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 12
              }}>
              <img src={logo} alt="logo" className="App-logo" />
              {/* { !prev_percentage ? 
                prev_message 
              : */}
                <ProgressBar
                  message={prev_message}
                  value={prev_percentage}
                />
              {/* } */}
            </Grid>
          </Grid>
        </div>
      );
    }
  } else {
    return (
      <div className="centered" style={{ 
          height: useHeight, 
          width: useWidth,
        }}>
        <Grid container spacing={0} direction="row" 
          style={{
            width: `${size}px`,
          }}>
          <Grid
            size={{
              xs: 12
            }}>
            <img src={logo} 
              style={{
                width: `${size}px`,
                height: `${size}px`,
              }} alt="logo" 
              className="App-logo" />
          </Grid>
          <Grid
            className="centered"
            size={{
              xs: 12
            }}>
            {/* { !prev_percentage ? 
              prev_message 
            : */}
              <ProgressBar
                message={prev_message}
                value={prev_percentage}
              />
            {/* } */}
          </Grid>
        </Grid>
      </div>
    );
  }
}
